<template>
  <div class="card-body px-0 pt-0 pb-3">
    <div class="table-responsive">
      <el-table border :data="completedPayments" class="el-table-css" style="width:100%;" show-summary
        :summary-method="getTableSummary">
        <el-table-column prop="paymentDate" label="Tarix" width="200" />
        <el-table-column label="Məbləğ (AZN)" width="150">
          <template #default="scope">
            {{ formatAmount(scope.row.amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Qeydlər" />
        <el-table-column width="80" fixed="right">
          <template #default="scope">
            <el-button class="fs-5" style="padding: 0px;" type="text" :icon="Edit" title="Düzəliş et" size="large"
              :disabled="status === 50" @click="$emit('edit-completed-payment', scope.row)">
            </el-button>
            <el-button class="fs-5" style="padding: 0px;" type="danger" :icon="Delete" title="Sil" size="large"
              :disabled="status === 50" text @click="$emit('delete-completed-payment', scope.row.id)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Delete, Edit } from "@element-plus/icons-vue";
export default {
  props: {
    completedPayments: {
      type: Array,
      required: true,
    },
    status: Number
  },
  data() {
    return {
      Delete,
      Edit,
    }
  },
  methods: {
    formatAmount(value) {
      if (value == null) return "-";
      let parts = Number(value).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(',');
    },
    getTableSummary({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Cəmi';
        } else if (
          column.label === 'Məbləğ (AZN)' ||
          column.property === 'amount'
        ) {
          const total = data.reduce((sum, row) => sum + Number(row.amount || 0), 0);
          sums[index] = this.formatAmount(total);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }
  },
  emits: ['copy-completed-payment', 'edit-completed-payment', 'delete-completed-payment']
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  align-items: center;
}

:deep(.el-table__footer td) {
  font-weight: bold !important;
}
</style>
